import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-bottom">
        <p>&copy; {currentYear} <span style={{ color: '#28a745' }}>A</span>I-Enhanced <span style={{ color: '#28a745' }}>A</span>nalytics & <span style={{ color: '#28a745' }}>I</span>ntegration for <span style={{ color: '#28a745' }}>M</span>odern <span style={{ color: '#28a745' }}>S</span>olutions. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
